<template>
  <div>
    <div :class="['box1',button?'box':'']" :style="{'width': slotWidth}">
      <slot name="el"/>
    </div>
    <div v-if="button" class="box2">
      <button type="button" @click="edit" :class="['el-button',size?'el-button--'+size:'']">
        <i class="iClass" :style="{'color':iFontColor}" :class="iClass"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props : {
    width: {
      type: Number,
      default: undefined
    },
    value: Boolean,
    size: String,
    button: {
      type: Boolean,
      default: true
    }
  },
  computed : {
    slotWidth(){
      if (this.width)
         return this.width - 30 + 'px'
      else
        return ''
    },
    iClass(){
      return this.value ? 'el-icon-s-tools':'el-icon-circle-check'
    },
    iFontColor(){
      return this.value ? '':'#13ce66'
    }
  },
  methods : {
    edit(){
      if (this.value){
        this.$emit('input',false)
      }else{
        this.$emit('configEdit')
      }
    }
  }
}
</script>

<style scoped>

.iClass {
  margin-right: 18px;
}

.box1 {
  display: inline-block;
  vertical-align: bottom;
}

.box2 {
  display: inline-block;
}

.box2 .el-button{
  width: 30px;
  border-left: 0px;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  padding: 12px 9px;
  background-color: #FFFFFF;
}

.box2 .el-button--small, .el-button--small.is-round {
  padding: 9px 9px;
}

.box /deep/ .el-input__inner{
  border-top-right-radius: unset;
  border-bottom-right-radius: unset;
}

.box /deep/ .el-button{
  border-top-right-radius: unset;
  border-bottom-right-radius: unset;
}
</style>
